/**
 * InfinitSales - Skeleton da janela de mensagens
 *
 * Seis bolhas alternadas (recebida a esquerda, enviada a direita) no cinza da
 * paleta que o skeleton da lista de conversas ja usa (colors.bgTertiary).
 * Aparece enquanto as mensagens da conversa ainda estao carregando e nenhuma
 * chegou; substitui o spinner central nos 4 inboxes (QR, Business, Instagram
 * e Messenger), que deixava a area em branco na primeira abertura.
 */
import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

// Largura (em % da area) e altura de cada bolha, para nao parecer uma grade.
const BOLHAS = [
  { width: 58, height: 38 },
  { width: 42, height: 38 },
  { width: 66, height: 56 },
  { width: 34, height: 38 },
  { width: 50, height: 38 },
  { width: 46, height: 56 },
];

const MessagesSkeleton = () => {
  const { colors } = useTheme();
  return (
    <div
      aria-hidden="true"
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        gap: 10,
        padding: '16px 18px',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      {BOLHAS.map((b, i) => {
        const enviada = i % 2 === 1;
        return (
          <div
            key={i}
            style={{ display: 'flex', justifyContent: enviada ? 'flex-end' : 'flex-start' }}
          >
            <div
              style={{
                width: `${b.width}%`,
                maxWidth: 360,
                height: b.height,
                borderRadius: 12,
                ...(enviada ? { borderBottomRightRadius: 4 } : { borderBottomLeftRadius: 4 }),
                backgroundColor: colors.bgTertiary,
                animation: 'is-messages-skeleton-pulse 1.5s infinite',
              }}
            />
          </div>
        );
      })}
      {/* Keyframe proprio: no mobile a lista (que declara o `pulse`) nao esta
          montada junto com a conversa. */}
      <style>{`
        @keyframes is-messages-skeleton-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
};

export default MessagesSkeleton;
